import { stringify } from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import { MAX_LIMIT } from 'config';

export default getShortFormVideoTopTracks;

export interface IProps {
  countryIds: string[];
  entityIds: string[];
  limit?: number;
  offset?: number;
  entityType: 'track' | 'artist' | 'album' | 'project';
  metricType?: 'views' | 'creations';
  download?: boolean;
}

function getShortFormVideoTopTracks(args: IProps): string {
  const {
    countryIds,
    entityIds,
    limit = MAX_LIMIT,
    offset,
    entityType,
    metricType,
    download,
  } = args;

  const apiEntityType = entityTypeToApiType(entityType);

  const params = stringify({
    countryIds,
    limit,
    offset,
    metricType,
    download,
  });

  return `/api/shortFormVideo/top/${apiEntityType}/${entityIds}/tracks${
    params !== '' ? `?${params}` : ''
  }`;
}
